import { TranslationContext } from "@clockwise/client-commons/src/providers/TranslationContext";
import { Link } from "@clockwise/design-system";
import { ChevronRight } from "@clockwise/icons";
import { getTimeZoneDisplayName } from "@clockwise/web-commons/src/util/time-zone.util";
import React, { useContext } from "react";
import { AutopilotStatusCard } from "./AutopilotStatusCard";

type Props = {
  meetingCount: number | undefined;
  timeZone: string;
  onClick?: () => void;
  badged?: boolean;
};

export function AutopilotStatusUnstarted({ meetingCount, timeZone, onClick, badged }: Props) {
  const t = useContext(TranslationContext);

  if (meetingCount === undefined) {
    return null;
  }

  if (meetingCount === 0) {
    return <AutopilotStatusCard title={t("autopilot-status:empty")} muted />;
  }

  return (
    <AutopilotStatusCard
      description={
        onClick ? (
          <>
            <Link>{t("autopilot-status:active", { count: meetingCount })}</Link>
            <ChevronRight className="cw-w-5 cw-h-5 cw-text-brand" />
          </>
        ) : (
          <div>{t("autopilot-status:active", { count: meetingCount })}</div>
        )
      }
      tooltipText={t("autopilot-status:tooltip", {
        timeZone: getTimeZoneDisplayName(timeZone),
      })}
      onClick={onClick}
      badged={badged}
    />
  );
}
